import { render } from "./Pasien.vue?vue&type=template&id=d1df052a"
import script from "./Pasien.vue?vue&type=script&lang=js"
export * from "./Pasien.vue?vue&type=script&lang=js"
script.render = render

export default script